<template>
  <div class="animated fadeIn">
      <b-form-group
              label="Select the File to Upload"
              description="This field is required"
      >
        <input
                class="form-control"
                type="file"
                id="formFileDisabled"
                accept="application/JSON"
                @change="readJsonFile"
                required
        />
      </b-form-group>

    <b-button type="submit" variant="success" block size="sm" @click="processImport()"><font-awesome-icon icon="save" /> Process Import</b-button>
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import { server_details } from "@/config";
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
      mixins:[SwalMixin],
      components: {NumberFormatComponent},
      data: () => {
          return {
            json_file:{},
            file:{},
          }
      },
      created(){
      },
      methods: {
        readJsonFile(e) {
          let files = e.target.files || e.dataTransfer.files;
          if (!files.length){
            this.swal_transaction_error_data.text = 'Invalid File';
            this.swalRequestError();
          }
          if(files[0].type!='application/json'){
            this.swal_transaction_error_data.text = 'Invalid File';
            this.swalRequestError();
          }

          this.file = files[0];
          this.readFile(files[0]);
        },
        readFile(file) {
          let reader = new FileReader();
          reader.onload = e => {
            //console.log(e.target.result);
            let json = JSON.parse(e.target.result);
            this.json_file =json;
          };
          reader.readAsText(file);
        },
          processImport(){
              this.swalConfirmSubmit((data)=>{
                  if (data.value) {
                      let formData = new FormData();
                      console.log(this.json_file)
                      formData.append("json_file", JSON.stringify(this.json_file));
                      formData.append("file", this.file);
                      this.axios.post("import/settings", formData, {
                          headers: {
                              "Content-Type": "multipart/form-data",
                          },
                          onUploadProgress: (progressEvent) => {
                              // this.percentage = parseInt(
                              //         Math.round((progressEvent.loaded * 100) / progressEvent.total)
                              // );
                          },
                      })
                          .then((response) => {
                              this.swalTransactionCompleted();
                          })
                          .catch(error => {
                              this.swal_transaction_error_data.text = error.response.data;
                              this.swalRequestError();
                          });
                  }
              });
          },
      }
    }
</script>
